import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

export default function CookieConsent() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has already made a choice
        const cookieChoice = localStorage.getItem('cookieConsent');
        if (!cookieChoice) {
            // Show banner after a short delay
            const timer = setTimeout(() => setIsVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setIsVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'declined');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className={`cookie-consent ${isVisible ? 'visible' : ''}`}>
            <div className="cookie-content">
                <div className="cookie-text">
                    <p>
                        Size daha iyi bir deneyim sunmak için çerezleri kullanıyoruz. Sitemizi kullanarak
                        <Link to="/privacy-policy"> Gizlilik Politikası</Link> ve
                        <Link to="/kvkk"> Çerez Politikamızı</Link> kabul etmiş sayılırsınız.
                    </p>
                </div>
                <div className="cookie-actions">
                    <button onClick={handleDecline} className="btn-cookie-decline">
                        Reddet
                    </button>
                    <button onClick={handleAccept} className="btn-cookie-accept">
                        Kabul Et
                    </button>
                </div>
            </div>
        </div>
    );
}
